"use client";

import { AlertTriangle } from "lucide-react";

import { CommonDialog } from "./CommonDialog";

interface TabLimitModalProps {
  open: boolean;
  title?: string;
  firstParagraph?: string;
  secondParagraph?: string;
}

export function TabLimitModal({
  open,
  title,
  firstParagraph,
  secondParagraph,
}: Readonly<TabLimitModalProps>) {
  return (
    <CommonDialog
      open={open}
      contentClassName="rounded-b-lg max-w-3xl mx-auto !p-0 !border-none"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseButton={false}
      title={
        <div className="flex items-center justify-center gap-3 w-full">
          <AlertTriangle className="h-7 w-7 text-white" aria-hidden="true" />
          <span className="text-3xl font-bold">{title}</span>
        </div>
      }
      titleClassName="bg-[#8b2626] text-white py-6 px-4 rounded-t-lg flex items-center justify-center"
    >
      <div className="px-6 py-4 space-y-4">
        {firstParagraph && <p className="text-[18px] leading-7 text-[#063353]">{firstParagraph}</p>}
        {secondParagraph && (
          <p className="text-[18px] leading-7 text-[#063353]">{secondParagraph}</p>
        )}
      </div>
    </CommonDialog>
  );
}

export default TabLimitModal;
